export var ApiHostName;
(function (ApiHostName) {
    ApiHostName["WIX"] = "www.wix.com";
    ApiHostName["MANAGE_WIX"] = "manage.wix.com";
    ApiHostName["GROUPS"] = "groups.wixapps.net";
    ApiHostName["EDITOR"] = "editor.wix.com";
    ApiHostName["EDITORX"] = "editorx.com";
    ApiHostName["EDITORWIXAPPS"] = "editor.wixapps.net";
    ApiHostName["DEV_WIX_CODE"] = "dev.wix-code.com";
})(ApiHostName || (ApiHostName = {}));
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    RequestStatus["PENDING"] = "PENDING";
    RequestStatus["APPROVED"] = "APPROVED";
    RequestStatus["REJECTED"] = "REJECTED";
})(RequestStatus || (RequestStatus = {}));
//# sourceMappingURL=types.js.map